import type { NormalizedAddress } from '@components/AddressCapture/AddressCapture.types';
import type { ResolvedAddress } from '@t/address.types';

/**
 * Narrows a provider-neutral address down to the qualification contract shape.
 *
 * Field-by-field rather than a spread on purpose: the provider extras
 * (`providerId`, coordinates, `needsUnit`) must not travel any further than the
 * address field, and a spread would quietly forward them into the qualification
 * request body.
 */
export const toNormalizedAddress = (address: ResolvedAddress): NormalizedAddress => ({
  unitNumber: address.unitNumber ?? '',
  streetNumber: address.streetNumber,
  streetName: address.streetName,
  city: address.city,
  province: address.province,
  country: address.country,
  postalCode: address.postalCode,
  formattedAddress: address.formattedAddress,
  displayAddress: address.displayAddress,
});
